import { Button } from "components/Button/Button";
import { stringToFormFieldComponent } from "components/Form";
import { requiredValidator } from "components/Form/Form.utils";
import { Form } from "components/Form/components/Form/Form";
import { FormField } from "config/config";
import { FormApi } from "final-form";
import { Field } from "react-final-form";
import "./MessageEditFields.scss";

interface MessageEditFieldsProps {
    formStructure: any;
    form: FormApi;
    submitted: boolean;
    submitForm;
    enableSave: boolean;
}

interface MessageFormFields extends FormField {
    order: number;
    fieldProps: FormField["fieldProps"] & {
        showTimeSelectOnly?: boolean;
        showTimeSelect?: boolean;
        initialValue?: any;
    };
}

export const MessageEditFields = ({
    formStructure,
    form,
    submitted,
    submitForm,
    enableSave,
}: MessageEditFieldsProps) => {
    const formFields: MessageFormFields[] = [
        {
            name: "is_submitted",
            order: 0,
            component: "switch",
            fieldProps: {
                label: "is_submitted",
            },
            fieldAttr: {
                hidden: true,
                disabled: submitted,
            },
        },
    ];
    Object.keys(formStructure?.properties || {}).forEach((field) => {
        const fieldProps = formStructure?.properties[field];
        const isRequired = formStructure?.required?.find((req) => field === req) !== undefined;
        const validation = isRequired && field !== "toggle-button" ? requiredValidator : undefined;

        const fieldMapper = {
            string: "text",
            number: "number",
            time: submitted ? "text" : "time",
            date: submitted ? "text" : "date",
            dateTime: submitted ? "text" : "dateTime",
            submit: "submit",
            markdown: "markdown",
            toggle: "switch",
        };
        let componentName = fieldProps?.element;
        if (componentName === "date-time") componentName = "dateTime";
        const initialValue =
            componentName === "toggle" ? fieldProps?.default ?? false : fieldProps?.default;

        formFields.push({
            name: field,
            order: fieldProps?.order,
            component: fieldMapper[componentName] || "text",
            fieldProps: {
                label: fieldProps?.element === "markdown" ? null : fieldProps?.label || field,
                showTimeSelectOnly: true,
                showTimeSelect: true,
                markdown: fieldProps?.docs,
                docs: fieldProps?.element === "markdown" ? null : fieldProps?.docs,
                initialValue,
            },
            fieldAttr: {
                required: isRequired || false,
                disabled: submitted,
                placeholder: fieldProps?.example,
            },
            validation,
        });
    });

    return (
        <>
            {formFields
                ?.sort((a, b) => a.order - b.order)
                ?.map((field) => {
                    if (field.component === "submit") {
                        return (
                            <Form.Row key={`resource-edit-form-${field.component + field.name}`}>
                                {/* dummy field for final-form. if we remove this, 
                            react-final-form will not remove the field in its 
                            internal model on unregister (see CU-861m43vyt / 
                            https://app.clickup.com/t/861m43vyt) */}
                                <Field name={field.name} component={() => null} />
                                <Button
                                    label={field?.fieldProps?.label}
                                    disabled={!enableSave || field?.fieldAttr?.disabled}
                                    onClick={() => {
                                        form.change(field.name, true);
                                        form.change("is_submitted", true);
                                        submitForm();
                                    }}
                                />
                            </Form.Row>
                        );
                    }
                    return (
                        <Form.Row key={`resource-edit-form-${field.component + field.name}`}>
                            <Field
                                name={field.name}
                                fieldProps={field.fieldProps}
                                fieldAttr={field.fieldAttr}
                                component={stringToFormFieldComponent[field.component]}
                                validate={field.validation}
                            />
                        </Form.Row>
                    );
                })}
        </>
    );
};
